import { AppConfig } from './app.abstract.config';

export const appConfig: AppConfig = {
  privileges: {
    notification: {
      duplicates: 'web:notification-duplicates',
      inviteToApply: 'web:notification-invite-to-apply',
      hiringManagerFlow: 'web:notification-hiring-manager-flow',
      referralExtended: 'web:notification-referral-extended',
    },
    job: {
      create: 'web:jobs-create',
      edit: 'web:jobs-edit',
      files: 'web:jobs-files',
      notes: 'web:jobs-notes',
      status: 'web:jobs-status',
      view: 'web:jobs-view',
      publish: 'web:jobs-publish',
      teamMembers: {
        view: 'web:jobs-team-members-view',
        edit: 'web:jobs-team-members-edit',
      },
    },
    candidates: {
      view: 'web:candiadtes-view',
      create: 'web:candiadtes-create',
      edit: 'web:candiadtes-edit',
    },
    companies: {
      view: 'web:companies-view',
      create: 'web:companies-create',
      edit: 'web:companies-edit',
    },
    reports: {
      view: 'web:reports-view',
      readAllTenants: 'rest:reports:read-all-tenants',
    },
    settings: {
      anonymization: 'web:settings-anonymization',
      user: 'web:settings-users',
      profile: 'web:settings-profile',
    },
    jobBoards: {
      viewPage: 'web:settings-job-boards',
    },
    talentPools: {
      view: 'web:talent-pools-view',
      create: 'web:create-talent-pool',
    },
    tasks: {
      view: 'web:tasks-view',
    },
  },
};
